// extracted by mini-css-extract-plugin
export var activeDot = "_35-c";
export var buttonContainer = "_35-9";
export var channelButton = "_35-a";
export var clickable = "_35-d";
export var content = "_35-0";
export var contentFull = "_35-2";
export var contentThird = "_35-1";
export var contentWrapper = "_35-7";
export var description = "_35-5";
export var heightShort = "_35-f";
export var image = "_35-3";
export var imageContainer = "_35-4";
export var selectButton = "_35-e";
export var spinnerContainer = "_35-b";
export var titleContent = "_35-8";
export var titleWrapper = "_35-6";